export default __webpack_public_path__ + "static/media/Thumb_Top_02.6f884b29.png";